export default __webpack_public_path__ + "images/5e908aaaa5f092db5f773ca652f22ae6-punk_music.webp";